import Box from '@mui/material/Box';
import MuiDivider from '@mui/material/Divider';
import type { PropsWithChildren, Ref } from 'react';

export type DropdownSectionAlignment = 'left' | 'center' | 'right';

export type Props = PropsWithChildren<{
  ref?: Ref<HTMLDivElement>;
  align?: DropdownSectionAlignment;
  tid?: string;
}>;

export function section(props: Props) {
  const { ref, children, align = 'left', tid } = props;
  const hasTitle = children !== undefined && children !== null;

  return (
    <Box ref={ref} data-testid={tid} sx={{ px: 1.5, py: hasTitle ? 0.75 : 0.625 }}>
      <MuiDivider
        textAlign={align}
        sx={{
          borderColor: '#D8D6DA',
          opacity: hasTitle ? 1 : 0.8,
          '&::before, &::after': {
            borderColor: '#D8D6DA',
          },
          '& .MuiDivider-wrapper': {
            px: 1,
            color: '#8A8790',
            fontSize: 10,
            fontWeight: 700,
            lineHeight: 1.4,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
          },
        }}
      >
        {hasTitle ? children : undefined}
      </MuiDivider>
    </Box>
  );
}

section.displayName = 'SiloReal-Dropdown-Section';
